import { manifestController } from 'magner';

const manifest = manifestController({
  name: 'hubstr',
  short_name: 'hubstr',
});

export default manifest;
